import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import DrawdownDetails from './DrawdownDetails'
import DrawdownCompareRow from './DrawdownCompareRow'
import './PerformanceTable.css'
import i18n from '../../../i18n'
import { setDrawDownPeriod } from '../../../actions'

class Drawdowns extends Component {
  setDrawDown(value) {
    this.props.setDrawDownPeriod(value)
  }

  formatDate(string) {
    return new Date(string).toLocaleDateString([], { timeZone: 'UTC' })
  }

  drawdownBtnClass(value) {
    const { drawdownNumber } = this.props
    let btnClass = value === drawdownNumber ? 'drawdownButton isselected' : 'drawdownButton notsselected'
    return btnClass
  }

  renderDrawdownCompareRows() {
    const { data, drawdownNumber } = this.props

    let drawdownPerformanceData = [...data]

    const drawdownCompareData = drawdownPerformanceData.filter(x => x.drawDownPerformance && x.drawDownPerformance.length > 0)
    if (drawdownCompareData.length > 0) {
      let allPerfDrawDowns = drawdownCompareData.map((fund, idx) => {
        if (fund.drawDownPerformance.length > drawdownNumber) {
          return fund.drawDownPerformance.slice(0, drawdownNumber)
        }
        if (fund.drawDownPerformance.length <= drawdownNumber) {
        }
        return fund.drawDownPerformance
      })
      let y = allPerfDrawDowns[0].slice(0, drawdownNumber).length // rows to show
      let elements = Array.from(Array(y).keys(), n => n)

      return (
        <Fragment>
          {elements.map((value, index) => {
            return <DrawdownCompareRow key={'dradown' + value.toString()} data={data} type={'compare'} index={index} />
          })}
        </Fragment>
      )
    } else return null
  }

  getFundLink = (fund) => {
    if (fund.type === 'BMK' || fund.type === 'BLEND' || fund.type === 'COD' || fund.type === 'WTMOD') {
      return fund.ticker.toUpperCase();
    }
    const url = fund.fundPageURL || fund.msUrl;
    return (
      <a className='tickerLink' href={url} target='_new'>
        {fund.ticker}
      </a>
    );
  };

  renderDrawdownCompareHeader(title) {
    const { data } = this.props

    //const hasData = data.filter((e) => e['drawDownPerformance']);

    const hasData = data.filter(x => x.drawDownPerformance !== null).filter(x => x.drawDownPerformance.length > 0)
    const tickers = hasData.map(fund => fund.ticker)
    const tickersStr = tickers.join(' vs ')
    let startD = this.formatDate(hasData[0].drawDownPerformance[0].startDate)
    let asOfDate = this.formatDate(hasData[0].drawDownPerformance[0].asOfDate)

    const getTickerContent = (fund) => {
      return fund.type === 'BMK' ? fund.ticker : this.getFundLink(fund);
    };    

    const tickerList = hasData.map(fund => (
      <th key={fund.ticker} className='textCenter'>
        {getTickerContent(fund)}
      </th>
    ));

    return (
      <thead>
        <tr>
          <th colSpan='10' className='textLeft'>
            {title.toUpperCase()} {tickersStr} {startD} to {this.formatDate(asOfDate)}
          </th>
        </tr>
        <tr>
          <th scope='col' className='textCenter'>
            {i18n.t('Drawdown Start')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Drawdown End')}
          </th>
          {tickerList}
        </tr>
      </thead>
    )
  }

  render() {
    const { type, data, drawdownNumber } = this.props

    let displayAsOfDate = this.formatDate(new Date())
    const asOfDate = this.formatDate(displayAsOfDate)
    //const asOfDate = '10/12/2022'
    if (type === 'drawdowns') {
      const drawdownTopData = data.filter(x => x.drawDownDetails && x.drawDownDetails.length > 0).slice(0, drawdownNumber)
      const drawdownCompareData = data.filter(x => x.drawDownPerformance && x.drawDownPerformance.length > 0).slice(0, drawdownNumber)

      if (drawdownCompareData.length > 0) {
        displayAsOfDate = data[0]?.drawDownPerformance?.[0]?.asOfDate
      }      

      return (
        <div>
          {drawdownTopData.length > 0 && (
            <div className='drawdown-btn-group'>
              <button onClick={() => this.setDrawDown('5')} type='button' className={'navButton ' + (drawdownNumber === '5' ? 'isselected' : 'notselected')}>
                5
              </button>
              <button onClick={() => this.setDrawDown('10')} type='button' className={'navButton ' + (drawdownNumber === '10' ? 'isselected' : 'notselected')}>
                10
              </button>
            </div>
          )}
          {drawdownTopData.length > 0 && (
            <div>
              <div className='table-responsive'>
                <table className='table tableFC'>
                  <DrawdownDetails />
                </table>
              </div>
              <div className='definition'>
                {i18n.t('drawdowns')}: {i18n.t('drawdowns-def')}
              </div>
            </div>
          )}
          {drawdownCompareData.length > 1 && (
            <div>
              <div className='drawdownTitle'>
               {i18n.t('DRAWDOWN COMPARISON').toUpperCase()} {i18n.t('as of')} {asOfDate}{' '}
              </div>
              <div className='table-responsive'>
                <table className='table tableFC'>
                  {this.renderDrawdownCompareHeader('Drawdown Comparison ')}
                  <tbody>{this.renderDrawdownCompareRows()}</tbody>
                </table>
              </div>
              <div className='definition'>{i18n.t('Periods used for drawdown comparison is determined by the first fund selected.')}</div>
            </div>
          )}
        </div>
      )
    } else {
      return null
    }
  }
}

function mapStateToProps(state) {
  return {
    data: state.fundData.data,
    drawdownNumber: state.params.drawdownNumber
  }
}

export default connect(mapStateToProps, { setDrawDownPeriod })(Drawdowns)
